import { ProgressSpinner } from 'primereact/progressspinner';
import styles from './Fallback.module.css';

const Fallback = () => {
  return (
    <div className={styles.fallback}>
      <ProgressSpinner />
    </div>
  );
};

export default Fallback;
